<template>
  <div class="allUsers">
    <div class="allUsers-left">
      <left-tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></left-tree>
    </div>
    <div class="allUsers-righ">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>

    <el-dialog
      custom-class="dialog-table"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="查看"
      :visible.sync="dialogVisibleApply"
      width="40%"
      :before-close="handleClose2"
    >
      <div class="" style="margin-bottom: 20px">
        <el-button type="primary" @click="addAreaAccreditApply"
          >新增授权</el-button
        >
      </div>
      <Table
        :width="'100%'"
        :tableLoading="tableLoadingApply"
        :tabelButtons="tabelButtonsApply"
        :templateData="tableTemplateDataApply"
        :tableConfig="tableConfigApply"
        :pagination="paginationApply"
      ></Table>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
    >
      <editForm
        ref="ruleForm"
        :formConfig="formConfig"
        :ruleForm="ruleForm"
        :rules="rules"
        :buttonConfig="buttonConfig"
      ></editForm>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title2"
      :visible.sync="dialogVisible2"
      :width="activeName !== '1' ? '1200px' : '800px'"
      :before-close="handleClose2"
    >
      <div
        class=""
        style="overflow: hidden"
        :style="{ height: activeName != '1' ? '500px' : '200px' }"
      >
        <el-tabs
          tab-position="left"
          v-model="activeName"
          @tab-click="handleClick"
          :style="{ height: activeName !== '1' ? '500px' : '200px' }"
        >
          <el-tab-pane name="1" label="绑定角色">
            <editForm
              ref="editForm"
              :formConfig="formConfig2"
              :ruleForm="ruleForm2"
              :rules="rules2"
              :buttonConfig="buttonConfig2"
            ></editForm>
          </el-tab-pane>
          <el-tab-pane
            v-if="title2 === '用户授权' && userType.indexOf('3') != -1"
            name="2"
            label="区域授权"
          >
            <div class="" style="margin-bottom: 20px">
              <el-button type="primary" @click="addAreaAccredit"
                >选择区域</el-button
              >
            </div>
            <el-table :data="jurisdictionLsit" max-height="450">
              <el-table-column prop="areaName" label="区域" width="150">
              </el-table-column>
              <el-table-column prop="date" label="勾选权限">
                <template slot-scope="scope">
                  <el-checkbox-group
                    @change="changeCheckbox($event, scope.row)"
                    v-model="scope.row.dataType"
                  >
                    <el-checkbox
                      :label="item.id"
                      :key="inx"
                      v-for="(item, inx) in jurisdictionData"
                      >{{ item.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="deleteRow(scope.row)"
                    type="text"
                    size="small"
                    >取消授权
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane
            v-if="title2 === '用户授权' && userType.indexOf('1') != -1"
            name="3"
            label="接警设置"
          >
            <div class="camera-title">接警摄像机：</div>
            <div class="camera-content">
              <el-table :data="vidiconSole" style="width: 100%">
                <el-table-column
                  prop="cameraName"
                  label="摄像机名称"
                  width="180"
                >
                </el-table-column>
                <el-table-column prop="areaName" label="区域" width="180">
                </el-table-column>
                <el-table-column prop="address" label="地址"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="delVidicon(scope.row)"
                      type="text"
                      size="small"
                      >解绑
                    </el-button>
                  </template>
                </el-table-column>
                <div slot="empty" style="height: 100px; line-height: 100px">
                  <el-button @click="addVidicon">添加摄像机</el-button>
                </div>
              </el-table>
            </div>
            <div class="camera-title">接警类型：</div>
            <div class="camera-content">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选
              </el-checkbox>
              <el-checkbox-group
                v-model="checkedVidiconSoleList"
                @change="getvidiconSoleChecked"
              >
                <el-checkbox
                  v-for="item in vidiconSoleList"
                  :label="item.itemName"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="camera-title">
              短信管理（短信不足时是否发送短信提醒）
            </div>
            <div class="camera-content">
              <el-radio v-model="alarmTypeRequest.isSms" :label="true"
                >是</el-radio
              >
              <el-radio v-model="alarmTypeRequest.isSms" :label="false"
                >否</el-radio
              >
            </div>
            <div class="btn" style="display: flex; justify-content: center">
              <el-button type="primary" @click="saveInfo">保存</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="title2 === '用户授权'" name="4" label="绑定机顶盒">
            <Table
              :width="'100%'"
              :tableLoading="tableLoading3"
              :tabelButtons="tabelButtons3"
              :templateData="tableTemplateData3"
              :tableConfig="tableConfig3"
              :pagination="pagination3"
            >
            </Table>
          </el-tab-pane>
          <el-tab-pane v-if="title2 === '用户授权'" name="5" label="绑定摄像机">
            <TabelSearch
              :searchConfig="searchConfig5"
              :reset="true"
              :searchTitle="'绑定'"
              :searchParams="searchParams5"
              @search="setSearchParams5"
            ></TabelSearch>
            <Table
              :width="'100%'"
              :tableLoading="tableLoading5"
              :tabelButtons="tabelButtons5"
              :templateData="tableTemplateData5"
              :tableConfig="tableConfig5"
              :pagination="pagination5"
            >
            </Table>
          </el-tab-pane>

          <el-tab-pane v-if="title2 === '用户授权'" name="6" label="摄像头操作">
            <div class="camera-title">摄像头控制：</div>
            <div class="camera-content">
              <el-checkbox
                :indeterminate="isCloudminate"
                v-model="checkCloudAll"
                @change="handleCloud"
                >全选
              </el-checkbox>
              <el-checkbox-group
                style="margin-top: 25px;"
                v-model="cloudSelectList"
                @change="getCloudChecked"
              >
                <el-checkbox
                  v-for="item in cloudList"
                  :label="item.itemName"
                ></el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="btn" style="display: flex; justify-content: center">
              <el-button type="primary" @click="saveCloudInfo">保存</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title2"
      :visible.sync="dialogVisible3"
      width="800px"
      :before-close="handleClose2"
    >
      <div class="" style="overflow: hidden" :style="{ height: '500px' }">
        <el-tabs
          tab-position="left"
          v-model="activeName2"
          @tab-click="handleClick"
          :style="{ height: '500px' }"
        >
          <el-tab-pane name="1" label="区域授权">
            <div class="" style="margin-bottom: 20px">
              <el-button type="primary" @click="addAreaAccredit"
                >选择区域</el-button
              >
            </div>
            <el-table :data="jurisdictionLsit" max-height="450">
              <el-table-column prop="areaName" label="区域" width="150">
              </el-table-column>
              <el-table-column prop="date" label="勾选权限">
                <template slot-scope="scope">
                  <el-checkbox-group
                    @change="changeCheckbox($event, scope.row)"
                    v-model="scope.row.dataType"
                  >
                    <el-checkbox
                      :label="item.id"
                      :key="inx"
                      v-for="(item, inx) in jurisdictionData"
                      >{{ item.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="deleteRow(scope.row)"
                    type="text"
                    size="small"
                    >取消授权
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="授权区域"
      :visible.sync="dialogAreaAccredit"
      width="800px"
      :before-close="areaAccreditClose"
    >
      <div class="space-between" style="height: 500px">
        <div class="left" style="height: 100%">
          <Tree
            v-if="dialogAreaAccredit"
            :showSwitch="false"
            :title="'指挥中心'"
            :areaId="choosedAreaId"
            :isfirstChoice="false"
            :switchVal="false"
            :showCheckbox="true"
            :areaTags="areaTags"
            @nodeClick="nodeClick2"
          ></Tree>
        </div>
        <div class="right" style="flex: 1; margin-left: 10px">
          <div class="">已选择地区:</div>
          <div class="areaAccredit">
            <el-tag
              v-for="tag in areaTags"
              :key="tag.name"
              style="margin-right: 10px; margin-bottom: 10px"
              closable
              @close="closable(tag)"
              :type="tag.type"
            >
              {{ tag.name }}
            </el-tag>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="areaAccreditClose">取 消</el-button>
        <el-button type="primary" @click="confirmArea">确 定</el-button>
      </span>
    </el-dialog>

    <!--区域认证-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="区域认证"
      :visible.sync="dialogAreaAccreditApply"
      width="800px"
      :before-close="areaAccreditCloseApply"
    >
      <div class="space-between" style="height: 500px">
        <div class="left" style="height: 100%">
          <Tree
            v-if="dialogAreaAccreditApply"
            :showSwitch="false"
            :title="'指挥中心'"
            :areaId="choosedAreaId"
            :isfirstChoice="false"
            :switchVal="false"
            :showCheckbox="true"
            :areaTags="applyTag"
            @nodeClick="nodeClick2"
          ></Tree>
        </div>
        <div class="right" style="flex: 1; margin-left: 10px">
          <div class="">已选择地区:</div>
          <div class="areaAccredit">
            <el-tag
              v-for="tag in applyTag"
              :key="tag.name"
              style="margin-right: 10px; margin-bottom: 10px"
              closable
              @close="closable(tag)"
              :type="tag.type"
            >
              {{ tag.name }}
            </el-tag>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="areaAccreditCloseApply">取 消</el-button>
        <el-button type="primary" @click="confirmAreaApply">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="绑定摄像机"
      :visible.sync="dialogVidiconAccredit"
      width="800px"
      :before-close="areaVidiconClose"
    >
      <TabelSearch
        :searchConfig="searchConfig2"
        :searchParams="searchParams2"
        @resetCallBack="resetCallBack2"
        @search="setSearchParams2"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading2"
        :tabelButtons="tabelButtons2"
        :templateData="tableTemplateData2"
        :tableConfig="tableConfig2"
        :pagination="pagination2"
      >
      </Table>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="绑定机顶盒"
      :visible.sync="dialogSTB"
      width="800px"
      :before-close="STBClose"
    >
      <editForm
        ref="ruleForm3"
        :formConfig="formConfig3"
        :ruleForm="ruleForm3"
        :rules="rules3"
        :buttonConfig="buttonConfig3"
      ></editForm>
    </el-dialog>
  </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
import Table from "../../../../components/table/table";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import editForm from "../../../../components/edit-form/edit-form";
import Tree from "../../../../components/Tree/nodeTreeUser";
import leftTree from "../../../../components/Tree/nodeTree";
import { userApi } from "../../../../api-path/user-api";
import { loginApi } from "../../../../api-path/login-api";
import publicApi from "../../../../api-path/public-api";
import { systemApi } from "../../../../api-path/system-api";
import { cameraApi, districtApi } from "../../../../api-path/district-api";
import { vidiconApi } from "../../../../api-path/vidicon-api";
import publicFn from "../../../../assets/js/publicFn";

export default {
  name: "allUsers",
  components: {
    Table,
    TabelSearch,
    editForm,
    Tree,
    leftTree,
  },
  data() {
    return {
      //区域授权code
      choosedAreaId: "",
      choosedAreaIdApply: "",
      treeAreaId: "",
      userType: "",
      //-------接警摄像机-------
      vidiconSole: [],
      dialogVidiconAccredit: false,
      checkAll: false,
      isIndeterminate: true,
      vidiconSoleList: [],
      checkedVidiconSoleList: [],
      sendMsg: false,
      alarmTypeRequest: {
        alarmType: "",
        isSms: false,
        userId: "",
      },


      cloudList: [],
      cloudSelectList: [],
      isCloudminate: true,
      cloudAttr: "",
      checkCloudAll: false,


      //-------绑定权限-----------
      title2: "",
      dialogVisible2: false,
      dialogVisible3: false,
      activeName: 1,
      activeName2: "1",
      //---------------------      区域授权   -----------------------------

      setParams: {
        userId: "",
        page: 1,
        size: 15,
      },
      applyTag: [],
      dialogVisibleApply: false,
      tableLoadingApply: false,
      tableTemplateDataApply: [],
      tabelButtonsApply: [],
      tableConfigApply: {
        checkbox: false,
        index: true,
        rows: [
          {
            label: "授权区域",
            prop: "areaName",
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "取消授权",
              fn: (data) => {
                this.$confirm("确定要取消此授权？, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    let declare = {
                      id: data.id,
                      ids: [data.userId],
                      status: 3,
                      text: null,
                    };
                    this.$http.post(userApi.areaCheck, declare).then((res) => {
                      if (res.status === 200) {
                        this.$message.success("取消授权成功");
                        this.authAreaByUserIdApply();
                      }
                    });
                  })
                  .catch(() => {});
              },
            },
          ],
        },
      },
      paginationApply: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChangeApply,
        pageChange: this.pageChangeApply,
      },

      applyList: [],
      dialogAreaAccreditApply: false,

      //-------------区域授权--------------
      areaTags: [], //已经选择区域
      jurisdictionLsit: [], //区域 角色权限
      jurisdictionData: [],
      areaTableData: [], //区域授权列表
      dialogAreaAccredit: false,
      //-----------人员信息------------
      switchVal: false,
      title: "修改用户信息",
      dialogVisible: false,
      // 搜索条件
      treeAreaId: 0,
      searchParams: {
        areaId: "0",
        isDown: false,
        userType: "",
        nameOrPhone: "", //名称或者帐号或者溯源ID
        page: 1,
        size: 15,
        terminal: "", //机顶盒
      },
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "userType",
            valueType: "select",
            placeholder: "选择用户类型",
            option: {
              label: "itemName",
              value: "itemValue",
            },
            path: publicApi.queryByCodeValue + "/PERSON_USER_TYPE",
            // data:[
            //     {name:'全部用户',id:''},{name:'普通用户',id:'0'},{name:'接警员',id:'1'},{name:'派警员',id:'2'},{name:'区域权限',id:'3'}
            // ],
          },
          {
            key: "nameOrPhone",
            placeholder: "输入姓名/手机号查询/id",
          },
          {
            key: "terminal",
            placeholder: "机顶盒",
          },
        ],
      },
      //表格
      tableLoading: false,
      tableTemplateData: [],
      tabelButtons: [
        {
          type: "add",
          code: "ADD",
          fn: () => {
            this.title = "新增用户";
            this.dialogVisible = true;
            this.rules.password[0].required = true;
            this.formConfig.items[1][0].disabled = false;
            this.formConfig.items[2][1].disabled = false;
            this.formConfig.items[3][0].disabled = false;
            this.ruleForm.areaId = this.areaId;
            this.ruleForm.areaName = this.areaName;
          },
        },
        // {
        //   type: "impower",
        //   code: "IMPOWER",
        //   title: "用户授权",
        //   fn: (data) => {
        //     this.title2 = "用户授权";
        //     this.dialogVisible2 = true;
        //     this.activeName = "1";
        //     this.bilingRoleView();
        //   },
        // },
        {
          title: "批量授权",
          type: "batchImpower",
          code: "IMPOWER",
          fn: () => {
            this.dialogVisible2 = true;
            this.title2 = "批量用户授权";
            this.activeName = "1";
            this.ruleForm2.areaId = this.areaId;
            this.ruleForm2.areaName = this.areaName;
            this.ruleForm2.roleId = "";
            this.getRoleList(this.ruleForm2.areaId);
            //授权，批量授权
          },
        },
        {
          type: "upload",
          code: "IMPORT",
          accept:
            "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          path: userApi.importData, // 请求路径
        },
        {
          type: "download",
          title: "模板下载",
          code: "EXPORT",
          path:
            userApi.templateDown +
            `?areaId=${this.treeAreaId ? this.treeAreaId : "0"}`, // 请求路径
        },

        {
          type: "delete", //删除
          path: userApi.delUser,
          paramsName: "ids:id",
          hintMessage: "是否删除所选信息？ 删除后将无法恢复，请谨慎操作",
          fn: this.startSearch,
        },


      ],
      tableDataId: "",
      tableConfig: {
        checkbox: true,
        checkboxFn: (data) => {
          this.ruleForm2.userIds = data.map((item) => {
            return item.id;
          });
          console.log(this.ruleForm2.userIds);
        },
        rows: [
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "账号",
            prop: "account",
          },
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "真实姓名",
            prop: "realName",
          },
          {
            label: "类型",
            prop: "userTypeName",
          },
          {
            label: "备注",
            prop: "remark",
            type: "popover",
            width: "150px",
          },
          {
            label: "区域认证",
            text: "查看",
            type: "button",
            fn: (data, index) => {
              // this.dialogVisible3 = true;
              // this.jurisdiction(data.id)
              console.log(data);
              this.tableDataId = data.id;
              this.userAreaApply(data.id);
            },
          },
          {
            label: "是否实名认证",
            activeText: "是",
            text: "否",
            type: "button",
            prop: "isAuth",
            fn: (data, index) => {
              this.$confirm("是否变更实名认证", "实名认证", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.$http
                    .get(loginApi.manualAuth, { params: { userId: data.id } })
                    .then((res) => {
                      if (res.status === 200) {
                        this.$message({
                          type: "success",
                          message: "操作成功!",
                        });
                        let dataNew = data;
                        dataNew.isAuth = !data.isAuth;
                        this.tableTemplateData.splice(index, 1, dataNew);
                      }
                    });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消操作",
                  });
                });
            },
          },

          /*     {
                 label: "是否实名认证",
                 prop: "isAuthName",
               },*/
          {
            width: "140px",
            label: "状态",
            prop: "enabled",
            type: "switch",
            fn: this.dataEnable,
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "编辑",
              fn: (data) => {
                this.$http
                  .get(userApi.viewUser, {
                    params: {
                      id: data.id,
                    },
                  })
                  .then((res) => {
                    if (res.status == 200) {
                      this.rules.password[0].required = false;
                      this.ruleForm = {
                        realName: res.result.realName, //真实姓名，
                        areaId: res.result.areaId, //注册区域
                        areaName: res.result.areaName, //注册名称
                        password: "", //密码
                        phone: res.result.phone, //手机
                        idCard: res.result.idCard, //身份证
                        remark: res.result.remark, //备注
                        id: res.result.id, //id
                        sex: res.result.sex, //性别
                        isTest: res.result.isTest, //用户类型
                        portrait: res.result.portrait, //头像
                        areaAuth: res.result.areaAuth,
                        portraitList: [{ url: res.result.portrait }],
                        account: res.result.account,
                      };
                      this.title = "修改用户信息";
                      this.formConfig.items[1][0].disabled = true;
                      /*this.formConfig.items[3][0].disabled = true;
                        this.formConfig.items[2][1].disabled = true;
                        this.formConfig.items[3][0].disabled = true;*/
                      this.dialogVisible = true;
                    }
                  });
              },
            },
            {
              label: "取消授权",
              type: "danger",
              fn: (data) => {
                console.log(data);
                const $this = this;
                this.$confirm("确认要取消授权, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    console.log("sdsdg");
                    $this.$http
                      .post(userApi.claerRole, { ids: [data.id] })
                      .then((res) => {
                        if (res.status == 200) {
                          $this.$message.success("取消授权成功！");
                          $this.startSearch();
                        }
                      });
                  })
                  .catch(() => {});
              },
            },
            {
              label: "用户授权",
              type: "warning",
              fn: (data) => {
                this.title2 = "用户授权";
                this.dialogVisible2 = true;
                this.activeName = "1";
                this.ruleForm2.userIds[0] = data.id;
                this.bilingRoleView();
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页
      //弹窗
      ruleForm: {
        realName: "", //真实姓名，
        areaId: "", //注册区域
        areaName: "", //注册名称
        password: "", //密码
        phone: "", //手机
        idCard: "", //身份证
        remark: "", //备注
        sex: "", //性别
        isTest: true, //用户类型
        areaAuth: true, //区域认证
        portrait: null, //头像，
        portraitList: [],
      },
      rules: {
        realName: [
          {
            required: true,
            message: "请输入真实姓名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            pattern: /^[A-Za-z0-9][\x20-\x7e]{5,20}$/,
            trigger: "blur",
            message: "请输入正确的密码格式(6-20位数组、字符、字母)",
          },
        ],
        areaName: [
          {
            required: true,
            message: "请选择注册区域",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            // pattern: /(^$)|^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],

        /*      ,idCard: [{
						required: true,
						message: '请输入正确的身份证号码',
						pattern: /(^\d{15}$)|(^\d{17}([0-9]|X|x)$)/,
						trigger: 'blur'
					}]*/
      },
      buttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              let obj = {
                realName: data.realName, //真实姓名，
                areaId: data.areaId, //注册区域
                areaName: data.areaName, //注册名称
                phone: data.phone, //手机
                id: data.id,
                idCard: data.idCard, //身份证
                remark: data.remark, //备注
                sex: data.sex, //性别
                isTest: data.isTest, //用户类型
                portrait:
                  data.portraitList.length != 0 ? data.portraitList[0].url : "", //头像
                areaAuth: data.areaAuth,
                account: data.account,
              };
              if (data.password != "") {
                obj.password = Base64.encode(data.password);
              }
              this.$http.post(userApi.saveAddUser, obj).then((res) => {
                if (res.status === 200) {
                  this.$message.success(this.title + "成功");
                  this.dialogVisible = false;
                  this.startSearch();
                  this.handleClose();
                }
              });
            },
          },
          {
            type: "back", // 返回
            fn: () => {
              this.handleClose();
            },
          },
        ],
      },
      formConfig: {
        disabled: false,
        items: [
          [
            {
              valueType: "upload", // 类型
              label: "头像",
              key: "portraitList", // 数据名称
              prop: "portraitList",
              itemWidth: "100%",
              labelWidth: "100px", // label 宽度
              disabled: false,
              otherConfig: {
                showInfoInput: false,
                imgWidth: "100px",
                imgHeight: "80px",
                method: ["delete", "edit"],
              },
              uploadConfig: {
                accept: "image/jpg,image/jpeg, image/png, image/tif, image/gif",
                uploadPath: publicApi.uploadFile,
                size: "20480kb",
                count: 1,
              },
              options: {
                fileUrlKey: "url",
                fileInfoKey: "description",
              },
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "手机号",
              key: "phone", // 数据名称
              prop: "phone", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 11,
              placeholder: "请输入手机号", // 提示信息
            },
            {
              valueType: "input", // 类型
              label: "密码",
              key: "password", // 数据名称
              prop: "password", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 20,
              placeholder: "请输入密码", // 提示信息
            },
          ],
          [
            {
              valueType: "tree-selected", // 类型
              label: "注册区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 50,
              placeholder: "请选择注册区域", // 提示信息
              fn: (data) => {
                //选择的值
                this.ruleForm.areaId = data.id;
                this.ruleForm.areaName = data.name;
              },
            },
            {
              valueType: "radio", // 类型
              label: "区域认证",
              disabled: false,
              key: "areaAuth", // 数据名称
              prop: "areaAuth", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              data: [
                {
                  value: true,
                  label: "是",
                },
                {
                  value: false,
                  label: "否",
                },
              ],
              options: {
                value: "v",
                label: "l",
              },
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "账号",
              disabled: false,
              key: "account", // 数据名称
              prop: "account", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: "50",
              placeholder: "请输入账号", // 提示信息
            },

            {
              valueType: "input", // 类型
              label: "真实姓名",
              disabled: false,
              key: "realName", // 数据名称
              prop: "realName", // 验证规则
              labelWidth: "100px", // label 宽度
              addressLocation: "addressLocation",
              itemWidth: "50%",
              maxlength: "50",
              placeholder: "请输入真实姓名", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "身份证",
              disabled: false,
              key: "idCard", // 数据名称
              prop: "idCard", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: "18",
              placeholder: "请输入身份证", // 提示信息
              fn: (data) => {
                if (
                  data.length == 18 &&
                  parseInt(data.slice(-2, -1)) % 2 == 1
                ) {
                  this.ruleForm.sex = "男";
                } else {
                  this.ruleForm.sex = "女";
                }
              },
            },

            {
              valueType: "input", // 类型
              label: "性别",
              disabled: true,
              key: "sex", // 数据名称
              prop: "sex", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请选择性别", // 提示信息
            },
          ],
          [
            {
              key: "isTest",
              label: "用户类型",
              valueType: "select",
              placeholder: "请选择用户类型",
              itemWidth: "50%",
              labelWidth: "100px", // label 宽度
              options: {
                label: "name",
                value: "value",
              },
              data: [
                {
                  name: "普通用户",
                  value: true,
                },
                {
                  name: "测试用户",
                  value: false,
                },
              ],
            },
            {
              valueType: "input", // 类型
              label: "备注",
              key: "remark", // 数据名称
              prop: "remark", // 验证规则
              maxlength: 50,
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入备注", // 提示信息
            },
          ],
        ],
      },
      //-------------用户角色授权-------------
      rules2: {
        realName: [
          {
            required: true,
            message: "请输入真实姓名",
            trigger: "blur",
          },
        ],
        roleId: [
          {
            required: true,
            message: "请输入角色 ",
            trigger: "blur",
          },
        ],
      },
      buttonConfig2: {
        buttons: [
          {
            type: "save", // 保存
            title: "授权",
            loading: false,
            fn: (data) => {
              let OBJ = JSON.parse(JSON.stringify(data));
              this.$http.post(userApi.bilingRole, OBJ).then((res) => {
                if (res.status == 200) {
                  this.userType = res.result;
                  this.choosedAreaId = res.result.id;
                  this.$message.success(this.title2 + "成功");
                }
              });
            },
          },
        ],
      },
      formConfig2: {
        disabled: false,
        items: [
          [
            {
              valueType: "tree-selected", // 类型
              label: "区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 50,
              placeholder: "请选择区域", // 提示信息
              fn: (data) => {
                // 点击新的区域时先判断是否是同一级，不是就清空选择的内容，以新选的区域为主
                console.log("areaParentId", this.areaParentId);
                console.log("data.parentId", this.areaParentId);

                if (this.areaParentId !== data.parentId) {
                  this.areaParentId = data.parentId;
                  this.areaSouquanClear();
                  this.ruleForm2.areaId = data.id;
                  this.ruleForm2.areaName = data.name;
                  this.getRoleList(data.id);
                  return;
                }

                //选择的值
                let ids = this.ruleForm2.areaId;
                let names = this.ruleForm2.areaName;

                let idsArr = ids !== "" ? ids.split(",") : [];
                let namesArr = names !== "" ? names.split(",") : [];

                if (idsArr.includes(data.id)) {
                  this.$message.error("当前区域已存在");
                  return;
                } else {
                  idsArr.push(data.id);
                  namesArr.push(data.name);
                }
                let idsStr = idsArr.join(",");
                let nameSStr = namesArr.join(",");

                this.ruleForm2.areaId = idsStr;
                this.ruleForm2.areaName = nameSStr;
                this.ruleForm2.roleId = "";
                this.getRoleList(idsStr);
              },
              clearFn: () => {
                console.log(1111);
                this.areaSouquanClear();
              },
            },
          ],
          [
            {
              label: "角色名称",
              key: "roleId", // 数据名称
              prop: "roleId", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 50,
              valueType: "select",
              placeholder: "请选择角色",
              options: {
                label: "name",
                value: "id",
              },
              data: [],
            },
          ],
        ],
      },
      areaParentId: "",
      ruleForm2: {
        //用户权限
        areaId: "",
        areaName: "",
        roleId: "",
        userIds: [],
      },
      //   ----------绑定摄像机-------------
      searchParams2: {
        areaId: "",
        search: "",
        isDown: true,
        page: 1,
        size: 5,
      },
      searchConfig2: {
        dataName: "searchParams2",
        items: [
          {
            key: "search",
            placeholder: "请输入摄像头名称",
          },
        ],
      },
      //表格
      tableLoading2: false,
      tableTemplateData2: [],
      tabelButtons2: [],
      tableConfig2: {
        checkbox: false,
        rows: [
          {
            label: "摄像机名称",
            prop: "name",
          },
          {
            label: "区域",
            prop: "areaName",
          },
          {
            label: "位置",
            prop: "address",
          },
        ],
        rowButtons: {
          width: "100px",
          items: [
            {
              label: "绑定",
              fn: (data) => {
                this.$http
                  .get(userApi.bilingCamer, {
                    params: {
                      cameraId: data.id,
                      userId: this.ruleForm2.userIds[0],
                    },
                  })
                  .then((res) => {
                    if (res.status == 200) {
                      this.dialogVidiconAccredit = false;
                      this.$message.success("绑定摄像机成功");
                      this.boundCameraList();
                    }
                  });
              },
            },
          ],
        },
      },
      pagination2: {
        show: true,
        total: 0,
        page: 1,
        size: 5,
        pageSizes: [5],
        sizeChange: this.sizeChange2,
        pageChange: this.pageChange2,
      }, // 分页
      //   ----------机顶盒-----------------
      dialogSTB: false,
      tableLoading3: false,
      tableTemplateData3: [],
      tabelButtons3: [
        {
          type: "add",
          title: "新增机顶盒",
          fn: () => {
            this.ruleForm3 = Object.assign(
              this.ruleForm3,
              this.$options.data().ruleForm3
            );
            delete this.ruleForm3.id;
            // console.log('ruleForm3', this.ruleForm3)
            this.dialogSTB = true;
          },
        },
      ],
      tableConfig3: {
        checkbox: false,
        rows: [
          {
            label: "卡号",
            prop: "terminalCode",
          },
          {
            label: "时间",
            prop: "createGmt",
          },
          {
            label: "类型",
            prop: "terminalTypeName",
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "编辑",
              fn: (data) => {
                this.ruleForm3 = JSON.parse(JSON.stringify(data));
                this.dialogSTB = true;
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.delData(data.id, "机顶盒", userApi.delSTB, "stbData");
              },
            },
          ],
        },
      },
      pagination3: {
        show: false,
      }, // 分页
      //添加机顶盒
      ruleForm3: {
        longitude: "", //经度
        latitude: "", //纬度
        address: "",
        createGmt: "",
        terminalType: "",
        terminalCode: "", //机顶盒卡号
        userId: "",
        netType: 1, //网络类型，默认外网
      },
      rules3: {
        terminalCode: [
          {
            required: true,
            message: "请输入机顶盒卡号",
            trigger: "blur",
          },
        ],
        terminalType: [
          {
            required: true,
            message: "请选择机顶盒类型",
            trigger: "blur",
          },
        ],
      },
      buttonConfig3: {
        position: "flex-end",
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              let OBJ = {
                createGmt: data.createGmt,
                id: data.id,
                terminalCode: data.terminalCode,
                terminalType: data.terminalType,
                netType: data.netType,
                userId: this.ruleForm2.userIds[0],
                latitude: data.latitude,
                longitude: data.longitude,
                address: data.address,
              };
              this.$http.post(userApi.bilingSTB, OBJ).then((res) => {
                if (res.status == 200) {
                  this.$message.success("绑定机顶盒成功");
                  this.dialogSTB = false;
                  this.ruleForm3 = Object.assign(
                    this.ruleForm3,
                    this.$options.data().ruleForm3
                  );
                  this.stbData();
                }
              });
            },
          },
          {
            type: "back", // 返回
            fn: () => {
              this.stbData();
              this.ruleForm3 = Object.assign(
                this.ruleForm3,
                this.$options.data().ruleForm3
              );
              this.dialogSTB = false;
            },
          },
        ],
      },
      formConfig3: {
        ref: "editMap",
        disabled: false,
        items: [
          [
            {
              valueType: "select", // 类型
              label: "机顶盒类型",
              key: "terminalType", // 数据名称
              prop: "terminalType", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: "100",
              path: publicApi.codeAndItem + "?codeValue=code_terminal_type",
              // data:[{itemName:'机顶盒1',itemValue:'1'},{itemName:'机顶盒2',itemValue:'2'}],
              options: {
                label: "itemName",
                value: "itemValue",
              },
              placeholder: "请选择类型", // 提示信息
            },
            {
              key: "terminalCode",
              label: "机顶盒卡号",
              prop: "terminalCode", // 验证规则
              valueType: "input",
              placeholder: "请输入机顶盒卡号",
              itemWidth: "50%",
              labelWidth: "100px", // label 宽度
            },
          ],
          [
            {
              key: "isTest",
              label: "经纬度",
              valueType: "nautica",
              placeholder: "请选择用户类型",
              itemWidth: "50%",
              labelWidth: "100px", // label 宽度
              fn: (data) => {
                this.ruleForm3.address = data.siteName;
              },
            },
            {
              valueType: "input", // 类型
              label: "地点",
              key: "address", // 数据名称
              prop: "address", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: "100",
              placeholder: "请输入地点", // 提示信息
            },
          ],
          [
            {
              valueType: "select", // 类型
              label: "网络类型",
              key: "netType", // 数据名称
              placeholder: "请选择网络类型", // 提示信息
              itemWidth: "50%",
              labelWidth: "100px", // label 宽度
              data: [
                {
                  label: "外网",
                  value: 1,
                },
                {
                  label: "内网",
                  value: 2,
                },
                {
                  label: "网络三",
                  value: 3,
                },
                {
                  label: "网络四",
                  value: 4,
                },
              ],
            },
          ],
        ],
      },
      //    绑定摄像机
      searchParams5: {
        tagId: "",
        userId: "",
        areaName: "",
        areaId: "",
      },
      searchConfig5: {
        dataName: "searchParams5",
        items: [
          {
            valueType: "tree-selected",
            key: "areaName", // 数据名称
            prop: "areaName", // 验证规则
            placeholder: "请选择所属辖区", // 提示信息
            fn: (data) => {
              //选择的值
              this.searchParams5.areaName = data.name;
              this.searchParams5.areaId = data.id;
              console.log(data);
              let params = {
                areaId: data.id,
                page: 1,
                size: 999,
              };
              this.searchConfig5.items[1].data = [];
              this.searchParams5.tagId = "";
              this.$http
                .get(vidiconApi.CameraTagList, {
                  params: params,
                })
                .then((res) => {
                  if (res.status == 200) {
                    this.searchConfig5.items[1].data = res.result.pageList;
                  }
                });
            },
          },
          {
            valueType: "select", // 类型
            key: "tagId", // 数据名称
            prop: "tagId", // 验证规则
            data: [],
            option: {
              label: "tagName",
              value: "id",
            },
            placeholder: "请选择摄像机标签", // 提示信息
          },
        ],
      },
      tableLoading5: false,
      tableTemplateData5: [],
      tabelButtons5: [],
      tableConfig5: {
        checkbox: false,
        rows: [
          {
            label: "摄像机标签名称",
            prop: "tagName",
          },
          {
            label: "区域",
            prop: "areaName",
          },
          {
            label: "地址",
            prop: "address",
          },
        ],
        rowButtons: {
          width: "100px",
          items: [
            {
              label: "解绑",
              type: "danger",
              fn: (data) => {
                this.delData(
                  data.id,
                  "摄像机",
                  userApi.unhideCamerTag,
                  "startSearch5"
                );
              },
            },
          ],
        },
      },
      pagination5: {
        show: false,
      }, // 分页
    };
  },
  mounted() {
    let allType = JSON.parse(localStorage.getItem("codeData")).ALARM_TYPE;
    allType.splice(0, 1);
    this.vidiconSoleList = allType;

    let cloudType = JSON.parse(localStorage.getItem("codeData")).CLOUD_TYPE;
    this.cloudList = cloudType;
  },
  beforeRouteLeave(to, form, next) {
    sessionStorage.removeItem("area");
    sessionStorage.removeItem("switch");
    next();
  },
  methods: {
    // 用户授权，绑定绝世区域清空
    areaSouquanClear() {
      this.ruleForm2.areaId = "";
      this.ruleForm2.areaName = "";
      this.ruleForm2.roleId = "";
      this.formConfig2.items[1][0].data = [];
    },
    // 每页显示条数
    sizeChange(size) {
      this.searchParams.size = this.pagination.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.searchParams.page = this.pagination.page = page;
      this.startSearch();
    },
    startSearch() {
      this.tableLoading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      //params.treeAreaId = this.treeAreaId;
      this.$http
        .get(userApi.allUserAll, {
          params: params,
        })
        .then((res) => {
          this.tableLoading = false;
          if (res.status == 200) {
            res.result.pageList.forEach((item) => {
              // item.isAuthName = item.isAuth ? "是" : "否";
              item.userTypeName = this.userTypest(item.userType);
            });
            this.tableTemplateData = res.result.pageList;
            this.pagination.total = res.result.total;
          }
        });
    },
    userTypest(item) {
      let arr = [];
      item.split(",").forEach((it) => {
        if (it == 0) {
          arr.push("普通用户");
        }
        if (it == 1) {
          arr.push("接警员");
        }
        if (it == 2) {
          arr.push("出警员");
        }
        if (it == 3) {
          arr.push("区域权限");
        }
      });
      return arr.join(",");
    },
    handleClose() {
      //关闭新增修改用户弹窗

      // this.ruleForm = Object.assign(this.ruleForm, this.$options.data().ruleForm);
      (this.ruleForm = {
        realName: "", //真实姓名，
        areaId: "", //注册区域
        areaName: "", //注册名称
        password: "", //密码
        phone: "", //手机
        idCard: "", //身份证
        remark: "", //备注
        sex: "", //性别
        isTest: true, //用户类型
        portrait: null, //头像
        portraitList: [],
        areaAuth: true,
      }),
        (this.dialogVisible = false);
    },
    handleClose2() {
      if (this.dialogVisible3) {
        this.dialogVisible3 = false;
      } else if (this.dialogVisibleApply) {
        this.dialogVisibleApply = false;
      } else {
        this.dialogVisible2 = false;
        this.handleClick({
          name: "1",
        });
      }
    },
    setSearchParams(value) {
      if (value) {
        this.pagination.page = value.page;
      }
      this.startSearch();
    },
    resetCallBack() {
      this.searchParams.userType = "";
      this.searchParams.nameOrPhone = "";
      this.searchParams.terminal = this.terminal;
      this.searchParams.areaId = this.areaId;
      this.searchParams.isDown = this.isDown;
      this.searchParams.page = this.pagination.page = 1;
      this.startSearch();
    },
    changeSwitch(e) {
      this.isDown = e;
      this.searchParams.isDown = e;
      this.searchParams.page = this.pagination.page = 1;
      this.startSearch();
    },
    nodeClick(node) {
      this.treeAreaId = node.id;
      this.areaId = node.id;
      this.areaName = node.id ? node.name : "";
      this.ruleForm.areaId = node.id;
      this.ruleForm.areaName = node.id ? node.name : "";
      this.ruleForm2.areaId = node.id;
      this.ruleForm2.areaName = node.id ? node.name : "";
      this.searchParams.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.tabelButtons[3].path = userApi.templateDown + `?areaId=${node.id}`;
      // sessionStorage.setItem('areaId', node.id)
      this.startSearch();
    },
    // 开启
    dataEnable(status, data) {
      this.$http
        .get(userApi.disableOrOpen, {
          params: {
            id: data.id,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success("用户状态更改成功");
          } else {
            data.enabled = !data.enabled;
          }
        });
    },
    getRoleList(id) {
      let obj = {
        areaId: id,
        isDown: false,
        page: 1,
        size: 999,
        isAuth: true,
      };
      this.$http
        .get(systemApi.getRoleList, {
          params: obj,
        })
        .then((res) => {
          if (res.status == 200) {
            this.formConfig2.items[1][0].data = res.result.pageList;
          }
        });
    },
    bilingRoleView() {
      let obj = {
        userId: this.ruleForm2.userIds[0],
      };
      this.$http
        .get(userApi.bilingRoleView, {
          params: obj,
        })
        .then((res) => {
          if (res.status == 200) {
            this.ruleForm2.areaId = res.result ? res.result.areaId : "";
            this.ruleForm2.areaName = res.result ? res.result.areaName : "";
            this.ruleForm2.roleId = res.result ? res.result.roleId : "";
            if (res.result && res.result.areaId) {
              this.choosedAreaId = res.result.areaId;
              this.getRoleList(res.result.areaId);
              this.areaParentId = res.result.parentId;
            }
            this.userType = res.result ? res.result.userType : "";
          }
        });
    },
    //
    changeCheckbox(e, row) {
      //区域授权
      let params = {
        areaId: row.areaId,
        isRegionalAuth: true,
        permissionIdList: e,
        roleId: this.ruleForm2.roleId,
        userId: this.dialogVisible3
          ? this.tableDataId
          : this.ruleForm2.userIds[0],
      };
      this.roleAuthorization(params);
    },
    deleteRow(row) {
      //取消授权
      let areaId = row.areaId;
      let index = this.jurisdictionLsit.findIndex((item) => {
        return item.areaId == areaId;
      });
      let params = {
        areaId: row.areaId,
        isRegionalAuth: true,
        permissionIdList: [],
        roleId: this.ruleForm2.roleId,
        userId: this.dialogVisible3
          ? this.tableDataId
          : this.ruleForm2.userIds[0],
      };
      this.$http.post(systemApi.roleAuthorization, params).then((res) => {
        if (res.status == 200) {
          this.$message.success("取消区域授权成功");
          row.dataType = [];
          this.jurisdictionLsit.splice(index, 1);
        }
      });
    },
    roleAuthorization(obj) {
      // let obj=JSON.parse(JSON.stringify(data));
      // obj.isRegionalAuth=!obj.isRegionalAuth
      this.$http.post(systemApi.roleAuthorization, obj).then((res) => {
        if (res.status == 200) {
          this.$message.success(
            obj.permissionIdList.length != 0 ? "区域授权成功!" : "取消授权成功!"
          );
          // this.jurisdiction()
        }
      });
    },
    handleClick(tab) {
      //点击
      switch (tab.name) {
        case "1":
          this.bilingRoleView();
          break;
        case "2":
          this.jurisdiction();
          break;
        case "3":
          this.boundCameraList(); //获取接警摄像机
          this.getAlarmTypeInfo(); //获取接警类型和短信管理
          break;
        case "4":
          this.stbData();
          break;
        case "5":
          this.cameraList();
          break;
        case "6":
          this.getAlarmTypeInfo();
          break;
      }
    },
    handlerDatas(arr) {
      // arr 传过来的原数组
      let tempArr = [];
      let endData = [];
      for (let i = 0; i < arr.length; i++) {
        if (tempArr.indexOf(arr[i].areaId) === -1) {
          endData.push({
            areaId: arr[i].areaId,
            areaName: arr[i].areaName,
            gbCode: arr[i].gbCode,
            children: [arr[i]],
          });
          tempArr.push(arr[i].areaId);
        } else {
          for (let j = 0; j < endData.length; j++) {
            if (endData[j].areaId == arr[i].areaId) {
              endData[j].children.push(arr[i]);
              break;
            }
          }
        }
      }
      return endData;
    },

    //---------------------------------------------------------区域认证

    userAreaApply(id) {
      this.setParams.userId = id;
      this.dialogVisibleApply = true;
      this.setParams.userId = id;
      this.$http
        .get(userApi.authAreaByUserIdApply, {
          params: this.setParams,
        })
        .then((res) => {
          this.tableTemplateDataApply = res.result.pageList;
          this.paginationApply.total = res.result.total;
        });
    },

    addAreaAccreditApply() {
      //添加区域授权
      let arr = [];
      this.applyList.map((x) => {
        arr.push({
          areaId: x.gbCode,
          areaTreeListRes: null,
          areaTreeListResList: null,
          id: x.areaId,
          isLast: false,
          name: x.areaName,
          parentId: x.areaName,
          setHotArea: false,
          type: null,
        });
      });
      this.applyTag = [];
      this.dialogAreaAccreditApply = true;
      setTimeout(() => {
        this.applyTag = arr;
      }, 200);
    },

    //---------------------------------------------------------区域授权
    jurisdiction(id) {
      let params2 = {
        isRegionalAuth: true,
        id: id ? id : this.ruleForm2.userIds[0],
      };
      this.jurisdictionLsit = [];
      this.jurisdictionData = JSON.parse(
        localStorage.getItem("ur")
      ).authSourceTreeDTOList;
      this.$http
        .get(systemApi.roleResourceTree, {
          params: params2,
        })
        .then((res) => {
          let arr = res.result;
          let jurisdictionLsit = this.handlerDatas(arr);
          let jurisdictionLsit2 = [];
          jurisdictionLsit.forEach((ite) => {
            let dataType = ite.children.map((v) => {
              return v.id;
            });
            jurisdictionLsit2.push({
              areaName: ite.areaName,
              gbCode: ite.gbCode,
              areaId: ite.areaId,
              dataType: dataType,
            });
          });
          jurisdictionLsit2.sort((a, b) => {
            return a.gbCode + "" > b.gbCode + "" ? 1 : -1;
          });
          this.$nextTick(() => {
            this.jurisdictionLsit = jurisdictionLsit2;
          });
        });
    },

    addAreaAccredit() {
      //添加区域授权
      let arr = [];
      this.jurisdictionLsit.map((x) => {
        arr.push({
          areaId: x.gbCode,
          areaTreeListRes: null,
          areaTreeListResList: null,
          id: x.areaId,
          isLast: false,
          name: x.areaName,
          parentId: x.areaName,
          setHotArea: false,
          type: null,
        });
      });
      this.areaTags = [];
      this.dialogAreaAccredit = true;
      setTimeout(() => {
        this.areaTags = arr;
      }, 200);
    },
    areaAccreditClose() {
      this.dialogAreaAccredit = false;
      this.choosedAreaId = "";
    },

    areaAccreditCloseApply() {
      this.dialogAreaAccreditApply = false;
      this.choosedAreaIdApply = "";
    },

    nodeClick2(node, checked) {
      this.areaTags = node;
      this.applyTag = node;
      // if(checked) {
      //   if (node.id) {
      //     let arr = this.areaTags.find((v) => {
      //       return v.id == node.id;
      //     });
      //     if (arr) {
      //       return false;
      //     } else {
      //       this.areaTags.push(node);
      //     }
      //   }
      // } else {
      //   let arr = JSON.parse(JSON.stringify(this.areaTags));
      //   arr.splice(
      //       arr.findIndex((el) => {
      //         return el.id === node.id;
      //       }),
      //       1
      //   );
      //   this.areaTags = arr;
      // }
    },

    closableApply(tag) {
      this.applyTag.splice(
        this.applyTag.findIndex((el) => {
          return el.id === tag.id;
        }),
        1
      );
      console.log(this.applyTag, tag);
    },

    closable(tag) {
      this.areaTags.splice(
        this.areaTags.findIndex((el) => {
          return el.id === tag.id;
        }),
        1
      );
      console.log(this.areaTags, tag);
    },

    confirmAreaApply() {
      if (this.applyTag.length === 0) {
        this.$message.error("请选择要授权的区域");
        return false;
      }
      this.$confirm("确定要为该用户授权已选的区域？, 是否继续?", "授权提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = [];
          this.applyTag.forEach((res) => {
            ids.push(res.id);
          });
          this.$http
            .post(userApi.areaApply, {
              id: this.setParams.userId,
              ids: ids,
              status: 4,
              text: "",
            })
            .then((res) => {
              if (res.status == 200) {
                this.$message.success("授权成功！");
                this.authAreaByUserIdApply();
                this.areaAccreditCloseApply();
              }
            });
        })
        .catch(() => {});
    },

    confirmArea() {
      let jurisdictionLsit = [];
      this.areaTags.forEach((ite) => {
        jurisdictionLsit.push({
          areaName: ite.name,
          areaId: ite.id,
          dataType: [],
        });
      });
      let config = [...this.jurisdictionLsit, ...jurisdictionLsit];
      let hash = {};
      const newArr = config.reduceRight((item, next) => {
        hash[next.areaName]
          ? ""
          : (hash[next.areaName] = true && item.push(next));
        return item;
      }, []);
      this.$nextTick(() => {
        this.jurisdictionLsit = newArr;
      });
      this.dialogAreaAccredit = false;
      this.areaTags = [];
    },
    //--------------------摄像机--------------------
    sizeChange2(size) {
      this.pagination2.size = size;
      this.searchParams2.size = size;
      this.startSearch2();
    },
    pageChange2(page) {
      this.pagination2.page = page;
      this.searchParams2.page = page;
      this.startSearch2();
    },
    resetCallBack2() {
      this.searchParams2.search = "";
      this.searchParams2.page = 1;
      this.startSearch2();
    },
    setSearchParams2(value) {
      if (value) {
        this.pagination2.page = value.page;
      }
      this.startSearch2();
    },
    boundCameraList() {
      //绑定的摄像机列表
      this.$http
        .get(userApi.bilingCamerView, {
          params: {
            userId: this.ruleForm2.userIds[0],
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.vidiconSole = res.result ? [res.result] : [];
          }
        });
    },
    getAlarmTypeInfo() {
      //获取接警类型和短信管理
      this.$http
        .get(userApi.findAlarmTypeOrsMS, {
          params: {
            userId: this.ruleForm2.userIds[0],
          },
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.result.alarmType) {
              if (res.result.alarmType == "99") {
                this.checkedVidiconSoleList = this.vidiconSoleList.map(
                  (item) => {
                    return item.itemName;
                  }
                );
                this.isIndeterminate = false;
                this.checkAll = true;
              } else {
                let idArr = res.result.alarmType.split(",");
                let newArr = [];
                idArr.map((item) => {
                  this.vidiconSoleList.map((citem) => {
                    if (citem.itemValue == item) {
                      newArr.push(citem.itemName);
                    }
                  });
                });
                this.checkedVidiconSoleList = newArr;
              }

              if (res.result.cloudType) {
                let cloArr = res.result.cloudType.split(",");

                if (cloArr.length == 3) {
                  this.cloudSelectList = this.cloudList.map((item) => {
                    return item.itemName;
                  });
                  this.isCloudminate = false;
                  this.checkCloudAll = true;
                } else {
                  let idArr = res.result.cloudType.split(",");
                  let newArr = [];
                  idArr.map((item) => {
                    this.cloudList.map((citem) => {
                      if (citem.itemValue == item) {
                        newArr.push(citem.itemName);
                      }
                    });
                  });
                  this.checkCloudAll = false;
                  this.isCloudminate = true
                  this.cloudSelectList = newArr;
                }
              } else {
                this.cloudSelectList = [];
                this.checkCloudAll = false;
                this.isCloudminate = false;
              }

              this.cloudAttr = res.result.cloudType;
              this.alarmTypeRequest.isSms = res.result.isSms;
              this.alarmTypeRequest.userId = this.ruleForm2.userIds[0];
              this.alarmTypeRequest.alarmType = res.result.alarmType;
            }
            this.alarmTypeRequest.isSms = res.result.isSms;
            this.alarmTypeRequest.userId = this.ruleForm2.userIds[0];
            this.alarmTypeRequest.alarmType = res.result.alarmType;
          }
        });
    },
    handleCheckAllChange(val) {
      if (val) {
        this.checkedVidiconSoleList = this.vidiconSoleList.map((item) => {
          return item.itemName;
        });
      } else {
        this.checkedVidiconSoleList = [];
      }
      this.isIndeterminate = false;
    },

    //选择接警类型
    getvidiconSoleChecked(value) {
      let idArr = value;
      if (idArr.length == this.vidiconSoleList.length) {
        //所有类型
        this.checkedVidiconSoleList = this.vidiconSoleList.map((item) => {
          return item.itemName;
        });
        this.alarmTypeRequest.alarmType = "99";
        this.checkAll = true;
      } else {
        this.checkedVidiconSoleList = idArr;
        let newArr = [];
        this.checkedVidiconSoleList.map((item) => {
          this.vidiconSoleList.map((citem) => {
            if (citem.itemName == item) {
              newArr.push(citem.itemValue);
            }
          });
        });
        this.checkAll = false;
        this.alarmTypeRequest.alarmType = newArr.toString();
      }
      this.isIndeterminate =
        idArr.length > 0 && idArr.length < this.checkedVidiconSoleList.length;
    },
    saveInfo() {
      this.$http
        .post(userApi.upAlarmTypeOrSms, this.alarmTypeRequest)
        .then((res) => {
          if (res.status == "200") {
            this.$message.success("保存信息成功！");
          }
        });
    },

    //云台控制

    handleCloud(val) {
      if (val) {
        this.cloudSelectList = this.cloudList.map((item) => {
          return item.itemName;
        });
      } else {
        this.cloudSelectList = [];
      }
      this.cloudAttr = this.cloudSelectList.length > 0 ? '1,2,3' : ''
      this.isCloudminate = false;
    },

    //选择云台类型
    getCloudChecked(value) {
      let idArr = value;
      if (idArr.length == this.cloudList.length) {
        //所有类型
        this.cloudSelectList = this.cloudList.map((item) => {
          return item.itemName;
        });
        this.cloudAttr = "1,2,3";
        this.checkCloudAll = true;
        this.isCloudminate = false;
      } else {
        this.cloudSelectList = idArr;
        let newArr = [];
        this.cloudSelectList.map((item) => {
          this.cloudList.map((citem) => {
            if (citem.itemName == item) {
              newArr.push(citem.itemValue);
            }
          });
        });
        this.checkCloudAll = false;
        this.cloudAttr = newArr.toString();
      }
      this.cloudminate =
        idArr.length > 0 && idArr.length < this.cloudSelectList.length;
    },

    saveCloudInfo() {
      let infos = {
        cloudType: this.cloudAttr,
        userId: this.ruleForm2.userIds[0],
      };
      this.$http.post(userApi.cloudController, infos).then((res) => {
        if (res.status == "200") {
          this.$message.success("保存信息成功！");
        }
      });
    },

    //选择短信管理
    startSearch2() {
      this.searchParams2.areaId = this.ruleForm2.areaId;
      this.$http
        .get(cameraApi.queryListByPage, {
          params: this.searchParams2,
        })
        .then((res) => {
          if (res.status == 200) {
            this.tableTemplateData2 = res.result.pageList;
            this.pagination2.total = res.result.total;
          }
        });
    },
    addVidicon() {
      this.dialogVidiconAccredit = true;
      this.startSearch2();
    },
    delVidicon() {
      //解绑摄像机
      this.$http
        .get(userApi.unhideCamer, {
          params: {
            id: this.ruleForm2.userIds[0],
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.$message.success("解绑成功");
            this.boundCameraList();
          }
        });
    },
    areaVidiconClose() {
      this.dialogVidiconAccredit = false;
    },
    cameraList() {
      this.$http
        .get(userApi.camerTagList, {
          params: {
            userId: this.ruleForm2.userIds[0],
          },
        })
        .then((res) => {
          if (res.status == 200) {
            console.log("绑定摄像机");
            console.log(res.result);
            this.tableTemplateData5 = res.result;
            // this.vidiconSole=res.result?[res.result]:[]
          }
        });
    },
    //--------------------机顶盒--------------------
    STBClose() {
      this.dialogSTB = false;
    },
    stbData() {
      let $this = this;
      $this.$http
        .get(userApi.listSTB, {
          params: {
            userId: this.ruleForm2.userIds[0],
          },
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.result.length > 0) {
              res.result.forEach((item) => {
                item.terminalTypeName = publicFn.filtrateCodeName(
                  "code_terminal_type",
                  item.terminalType
                );
              });
            }
            $this.tableTemplateData3 = res.result;
          }
        });
    },
    delData(id, name, url, fn) {
      this.$confirm(`此操作将删除该${name}数据, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .delete(url, {
              params: {
                id: id,
              },
            })
            .then((res) => {
              if (res.status == 200) {
                this.$message.success("刪除成功");
                this[fn]();
              }
            });
        })
        .catch(() => {});
    },
    //--------------------摄像机--------------------
    setSearchParams5(value) {
      if (value) {
        this.pagination5.page = value.page;
      }
      this.bilingCamerTag();
    },
    startSearch5() {
      this.$http
        .get(userApi.camerTagList, {
          params: {
            userId: this.ruleForm2.userIds[0],
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.tableTemplateData5 = res.result;
          }
        });
    },
    bilingCamerTag() {
      if (this.searchParams5.tagId) {
        this.searchParams5.userId = this.ruleForm2.userIds[0];
        this.$http
          .get(userApi.bilingCamerTag, {
            params: this.searchParams5,
          })
          .then((res) => {
            if (res.status == 200) {
              this.$message.success("绑定摄像头成功");
              this.startSearch5();
            }
          });
      } else {
        this.$message.error("请选择绑定摄像头条件，再做绑定操作");
      }
    },

    //--------------------------------------------- 区域授权
    sizeChangeApply(size) {
      this.paginationApply.size = size;
      this.setParams.size = size;
      this.authAreaByUserIdApply();
    },

    pageChangeApply(page) {
      this.paginationApply.page = page;
      this.setParams.page = page;
      this.authAreaByUserIdApply();
    },
    authAreaByUserIdApply() {
      this.$http
        .get(userApi.authAreaByUserIdApply, { params: this.setParams })
        .then((res) => {
          this.tableLoadingApply = false;
          if (res.status == 200) {
            this.tableTemplateDataApply = res.result.pageList;
            this.paginationApply.total = res.result.total;
          }
        });
    },
  },
};
</script>

<style lang="less">
.allUsers {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  overflow-x: auto;

  .allUsers-left {
    margin-right: 4px;
    border-right: 1px solid #c1c1c1;
  }

  .allUsers-righ {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .el-form-item__error {
    top: 100%;
    /* left: 0; */
  }

  .el-tabs__content {
    display: block !important;
  }

  .areaAccredit {
    height: 90%;
    background: rgba(241, 246, 248, 1);
    padding: 10px;
    margin-top: 10px;
  }

  .camera-content {
    margin: 15px 0;
  }

  .el-table__body-wrapper {
    height: 200px;
  }
}
</style>
